import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-cash-receipt-download',
  templateUrl: './cash-receipt-download.component.html',
  styleUrls: ['./cash-receipt-download.component.scss']
})
export class CashReceiptDownloadComponent implements OnInit {
  title: any;
  booth_code: any = null;
  ordered_date: any = null;
  data_loading = false;
  cash_receipt_data: any = [];

  constructor(private globalService: GlobalService, private httpService: HttpService) {
    this.title = this.globalService._active_display_name;
  }

  serveCashReceipt() {
    let data_dict = {
      'booth_code': this.booth_code,
      'ordered_date': this.ordered_date
    }
    this.data_loading = true;
    this.httpService.downloadCashReceipt(data_dict).subscribe((data: any = []) => {
      console.log(data);
      this.cash_receipt_data = data;
      if (data.length == 0) {
        alert('Data Not Available');
      }
      this.data_loading = false;
    }, (error) => {
      this.data_loading = false;
      console.error(error)
    });
  }

  downloadReceipt(obj) {
    const linkSource = 'data:application/pdf;base64,' + obj['file_in_base_64'];

    const downloadLink = document.createElement("a");
    const fileName = 'Cash Receipt file';
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  ngOnInit() {
  }

}
